import {
  IGetPermissionsResponse,
  IRegisterUserForm,
  IUserResponse,
} from "services/userManagement/types";

export const userQueryToForm = (
  userQuery: IUserResponse,
  permissionsQuery: IGetPermissionsResponse
): IRegisterUserForm => {
  const { id, permissions, ...user } = userQuery;

  return {
    ...user,
    isTwoFactorEnabled: false,
    permissions: permissionsQuery.permissions.reduce((acc, permission) => {
      const domainName = permission.item1.permissionDomainName;

      if (!acc[domainName]) {
        acc[domainName] = {
          domain: domainName,
          permissions: [],
        };
      }

      acc[domainName].permissions.push({
        flag: permission.item1.permissionFlagValue,
        isSelected: permission.item2,
      });

      return acc;
    }, {} as Record<string, { domain: string; permissions: { flag: number; isSelected: boolean }[] }>),
  };
};
